export const EMAIL_NOT_VERIFIED_CODE = 'EMAIL_NOT_VERIFIED';

export const requiresEmailVerification = (user) => {
  if (!user || user.emailVerified) return false;

  const providers = Array.isArray(user.providerData) ? user.providerData : [];
  return providers.some((provider) => provider?.providerId === 'password');
};

export const pendingEmailProfileKey = (uid) => `journeybot.pendingEmailProfile.${uid}`;

